import React, { useEffect, useRef } from 'react'
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete'
import useOnclickOutside from 'react-cool-onclickoutside'
import styled from 'styled-components'

const InputContainer = styled.div`
  position: relative;
`

const Input = styled.input`
  background: transparent;
  border: none;
  border-bottom: 1px solid white;
  margin: 0.5rem 0;
  color: inherit;
  font-size: inherit;
  font-weight: 100;
  max-width: 100vw;

  &:focus {
    outline: none;
  }
`

const List = styled.ul`
  z-index: 1;
  position: absolute;
  left: 0;
  right: 0;
  text-align: left;
  margin: 0;
  padding: 0;
`

const ItemContainer = styled.li`
  list-style: none;
  display: flex;
  flex-direction: column;
  background: white;
  border-bottom: 1px solid #dfdfdf;
  padding: 0.5rem 1rem;

  &:hover {
    cursor: pointer;
  }
`

const Title = styled.span`
  font-weight: 200;
  font-size: 1.5rem;
`

const Small = styled.span`
  font-size: 1rem;
  font-weight: 200;
  color: #666;
`

const PlacesInput = ({ focus, setGeolocation, placeholder }) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: {
        country: 'au',
      },
    },
    debounce: 300,
  });
  const ref = useOnclickOutside(clearSuggestions)
  const inputRef = useRef()

  const handleInput = (e) => {
    const { value } = e.target
    setGeolocation();
    setValue(value)
  }

  const handleSelect = ({ description }) => () => {
    setValue(description, false);
    clearSuggestions();

    getGeocode({ address: description })
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        setGeolocation({ lat, lng });
      })
      .catch((error) => {
        console.log("😱 Error: ", error);
      });
  };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <ItemContainer key={id} onClick={handleSelect(suggestion)}>
          <Title>
            {main_text}
          </Title>
          <Small>
          {secondary_text}
          </Small>
        </ItemContainer>
      );
    });
  useEffect(() => {
    focus && inputRef.current.focus()
  }, [inputRef.current])

  return (
    <InputContainer ref={ref}>
      <Input
        ref={inputRef}
        value={value}
        onChange={handleInput}
        disabled={!ready}
        placeholder={placeholder}
      />
      {status === "OK" && <List>{renderSuggestions()}</List>}
    </InputContainer>
  );
};

export default PlacesInput
